import { useState, useEffect } from 'react';
import { nanoid } from 'nanoid';

const KEY = 'create_recipe_idempotency_token';

const useIdempotencyToken = () => {
  const [idempotencyToken, setIdempotencyToken] = useState(
    sessionStorage.getItem(KEY)
  );

  useEffect(() => {
    const clearToken = () => {
      sessionStorage.removeItem(KEY);
    };

    const createToken = () => {
      const storedToken = sessionStorage.getItem(KEY);

      const token = () => (!storedToken ? nanoid() : storedToken);
      const currentToken = token();

      sessionStorage.setItem(KEY, currentToken);
      return currentToken;
    };

    const start = () => {
      setIdempotencyToken(createToken());
    };
    start();

    return () => {
      clearToken();
    };
  }, []);

  return { idempotencyToken };
};

export default useIdempotencyToken;
